<template>
  <div
    class="user-popover"
    ref="container"
  >
    <div class="user-info">
      <img
        class="avatar"
        :src="getAvatar"
        :width="avatar.width"
        :height="avatar.height"
      >
      <div class="info">
        <div class="full-name">
          {{ currentStudent.FullName || account?.FullName }}
        </div>
        <router-link
          class="profile-detail label"
          to="/student/profile/general"
          @click="hide"
        >
          {{ $t('User.ShowAccountDetail') }}
        </router-link>
      </div>
    </div>
    <div class="user-option">
      <div
        class="option-item"
        v-for="(option, index) in options"
        :key="index"
        @click="option.onClick"
      >
        <img
          :src="option.icon"
          :width="20"
          :height="20"
        >
        <div>{{ option.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseList from '@/views/base/base-list'
import { getContextData, ContextDataKey } from '@/utils/context-data'
import { mapState, mapActions } from 'vuex'
import { logout } from '@/views/pages/account/common/common-function'
import { AppTheme, setTheme } from '@/utils/theme'

const ChangePassword = () => require('./change-password-popup')

const UPDATE_VISIBLE_VALUE = 'update:visible'

export default {
  extends: BaseList,

  emits: [UPDATE_VISIBLE_VALUE],

  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      changePasswordPopupName: 'ChangePasswordPopup',
      /**
       * ảnh đại diện
       */
      avatar: {
        width: 64,
        height: 64
      },
      account: getContextData()
    }
  },

  computed: {
    ...mapState('student', { currentStudent: 'currentStudent' }),
    /**
     * Tùy chọn thay đổi thông tin
     */
    options () {
      const me = this
      const list = [
        {
          iconName: 'ic_classroom',
          business: 'ClassroomList',
          event: me.showClassroomList
        },
        {
          iconName: 'ic_User_20',
          business: 'AccountDetail',
          event: me.showAccountDetail
        },
        {
          iconName: 'ic_Password_20',
          business: 'ChangePassword',
          event: me.showChangePassword
        },
        // {
        //   iconName: 'ic_Help_20',
        //   business: 'Help',
        //   event: () => {}
        // },
        {
          iconName: 'ic_Diary_20',
          business: 'ActivityLog',
          event: me.showActivityLog

        },
        {
          iconName: 'changing',
          business: 'ThemeSetting',
          event: me.showThemeSetting
        },
        {
          iconName: 'ic_LogOut_20',
          business: 'Logout',
          event: me.onLogout
        }
      ]

      return list.map(option => {
        return {
          icon: require(`@/assets/icons/svg/user_info/${option.iconName}.svg`),
          text: me.$t(`User.${option.business}`),
          onClick: option.event
        }
      })
    },

    /**
     * Xử lý hiển thị avatar theo Image
     */
    getAvatar () {
      const me = this
      var image = me.currentStudent.Image || getContextData(ContextDataKey.Image)
      // Nếu null thì trả về ảnh đại diện mặc định
      if (!image) {
        return require('@/assets/images/svg/avatar/student/default/default.svg')
      } else {
        // Nếu Image trả về nhỏ hơn 10 (xử lý sau) thì trả về ảnh đại diện lấy từ assets
        if (image.length < 10) {
          return require('@/assets/images/svg/avatar/student/' + image + '.svg')
        } else {
          // Còn lại trả về Image dạng ID hoặc link
          // return getContextData(ContextDataKey.Image)
          return me.$commonFn.buildPreviewFileUrl({
            fileId: image,
            storageType: me.$enumeration.StorageType.StudentAvatar,
            ownerId: getContextData(ContextDataKey.UserID),
            clientFileName: '',
            isPreview: true,
            width: '47'
          })
        }
      }
    }
  },

  methods: {
    ...mapActions('class-room', ['updateViewActive']),
    /**
     * Hàm lấy ref container
     */
    getContainer () {
      return this.$refs.container
    },

    /**
     * Hàm lấy tên popup
     */
    async getOtherPopup (componentName) {
      let res = () => {}
      componentName === this.changePasswordPopupName && (res = ChangePassword)
      return await res()
    },

    /**
     * Hàm ẩn popover thông tin học sinh
     */
    hide () {
      this.$emit(UPDATE_VISIBLE_VALUE, false)
    },

    /**
     * @author PVThang
     * @description Đăng xuất
     */
    onLogout () {
      setTheme(AppTheme.Normal)
      logout()
    },

    /**
     * @author PVThang
     * @description redirect về trang đổi mật khẩu
     */
    showChangePassword () {
      const me = this
      me.$router.push('/student/profile/detail/change-password')
      me.hide()
    },

    /**
     * @description redirect về trang quản lý tài khoản
     */
    showAccountDetail () {
      const me = this
      me.$router.push('/student/profile/detail/account-info')
      me.hide()
    },

    /**
     * @description redirect sang quản lý lớp học
     */
    async showClassroomList () {
      const me = this
      await me.updateViewActive(me.$enumeration.ClassroomType.ChooseClassroom)
      me.$router.push('/student/classroom')
      me.hide()
    },

    /**
     * @description redirect về trang nhật ký hoạt động
     */
    showActivityLog () {
      const me = this
      me.$router.push('/student/profile/detail/log-activity-student')
      me.hide()
    },

    /**
     * @description redirect về trang thiết lập giao diện
     */
    showThemeSetting () {
      const me = this
      me.$router.push('/student/profile/detail/theme-setting')
      me.hide()
    }
  }
}
</script>

<style lang="scss" scoped>
.user-popover {
  .user-info {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid $color-neutral-light-1;
    margin: 0 12px;
    .profile-detail {
      color: $color-accent;
    }
    .avatar {
      margin: 12px 15px 24px 0;
      border-radius: $border-radius-circle;
      background-color: $color-neutral-light-1;
    }
    .info {
      padding-bottom: 16px;
      .full-name {
        @include title();
        color: $color-neutral-light-5;
        margin-top: 6px;
        text-align: left;
        word-break: break-word;
      }
      a {
        text-decoration: none;
      }
    }
  }
  .user-option {
    padding-top: 6px;
    .option-item {
      @include subtitle();
      display: flex;
      height: 36px;
      align-items: center;
      cursor: pointer;
      border-radius: $border-radius-base;
      color: $color-neutral-light-4;
      margin: 6px 0;
      img {
        margin: 0 8px;
      }
    }
    .option-item:hover {
      background-color: rgba(138, 107, 246, 0.2);
      color: $color-accent;
    }
  }
}
</style>
